import { z } from 'my-zod'
import { riderModel } from './rider-model'

export const riderShortView = riderModel.pick({
  id: true,
  email: true,
  guestType: true,
  firstName: true,
  lastName: true,
  phone: true,
  transactionalSMSOptIn: true
})

export type riderShortView = z.infer<typeof riderShortView>
